import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ArrowLeftOutlined, EditFilled, DeleteFilled, PlusOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { IconShare } from 'Components/Icons';
import { THEME, approvalType, vendorApprovalStatusTypes } from 'Util/constants';
import { useHistory } from 'react-router-dom';
import str from 'string-sanitizer'
import CommonConfirmModal from 'Components/Modal/ModalConfirm';
import { useRecoilState } from 'recoil';
import { driverDetailAtom } from '../../../../../Store/logisticsAtom';
import { useRequestAproval } from '../../../../../Hooks/approval';
import { getApprovalWorkFlow } from '../../../../../Util/common';
import User from 'Hooks/user';
import { notification } from 'antd';
import PreApproveModal from '../../../../../Components/Modal/PreApproveModal';
import { useMutation } from '@apollo/client';
import { UPDATE_DRIVERS } from 'Util/mutations';

const menu = [
    { label: "Process" },
    { label: "Request Approval" }
]

const Container = styled.div`
    .actions-wrapper{

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        &>div{
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .icons-wrapper{
            justify-content: flex-end;
            width: 180px;
            gap: 20px;
            svg{
                color: ${THEME.colors.primary};
                font-size: 25px;
                cursor: pointer;
            }
        }

        .backIconWrapper{
            background-color: ${THEME.colors.primary};
            border-radius: 50%;
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            border: none;
        }
        h1{
            margin: 0px 10px;
        }

    }

    .submenu-wrapper{

        padding: 10px 0px;
        border-bottom: solid #555 thin;
        border-top: solid #555 thin;
        margin: 20px 0px;

        &>a{
            color: #555;
            margin: 0px 10px;
            font-size: 16px;
            font-weight: 500;
            &[disabled]{
                color: #ccc;
                .anticon{
                    color: #ccc !important;
                }
            }
        }
    }
`

const SecondMenu = ({ onMenuClick, currentStatus }) => {

    const menu2 = [
        { icon: null, label: "Pre-Approval" },
        { icon: <CheckOutlined style={{ color: THEME.colors.primary }} />, label: "Send Approval Request", status: [vendorApprovalStatusTypes.APPROVED] },
        { icon: <CloseOutlined style={{ color: 'red' }} />, label: "Cancel Approval Request", status: [vendorApprovalStatusTypes.APPROVED] },
    ]

    return menu2.map(v => {
        if (v.status === undefined) {
            return (
                <a key={`driver-header-${str.addDash(v.label)}`} onClick={() => onMenuClick(v.label)}>
                    {v.icon && <span style={{ marginRight: 5 }}>{v.icon}</span>}
                    {v.label}
                </a>
            )
        }
        return (
            <a
                disabled={!v.status.includes(currentStatus)}
                key={`driver-header-${str.addDash(v.label)}`}
                onClick={() => v.status.includes(currentStatus) && onMenuClick(v.label)}
            >
                {v.icon && <span style={{ marginRight: 5 }}>{v.icon}</span>}
                {v.label}
            </a>
        )
    })
}


function Header({ editMode = false, setDisabled, onEvent }) {

    const history = useHistory()
    const [driver, setDriver] = useRecoilState(driverDetailAtom)
    const [showPreApprove, setShowPreApprove] = useState(false)

    const { requestApproval } = useRequestAproval()
    const { user_id } = User()

    const [updateDriver] = useMutation(UPDATE_DRIVERS)

    const backHandler = () => {
        history.goBack()
    }

    const preApproveHandler = (action) => {

        updateDriver({
            variables: {
                where: { id: { _eq: driver.id } },
                _set: { status: action === 'reject' ? vendorApprovalStatusTypes.REJECTED : vendorApprovalStatusTypes.APPROVED }
            }
        }).then(() => {
            setDriver(prev => ({ ...prev, status: action === 'reject' ? vendorApprovalStatusTypes.REJECTED : vendorApprovalStatusTypes.APPROVED }))
            notification['success']({
                message: action === 'reject' ? 'Rejected!' : 'Approved!',
                description: `Driver has been ${action === 'reject' ? 'rejected' : 'approved'}!`,
            });
        })
        onEvent && onEvent(`preapprove-${action}`)
        setShowPreApprove(false)
    }

    const subMenuClickHandler = (val) => {

        switch (val) {
            case "Pre-Approval":
                setShowPreApprove(true)
                break;

            case "Send Approval Request":

                CommonConfirmModal({
                    content: `Request Final Approval for ${driver.name}'s On-Boarding.`,
                    okText: "Yes",
                    cancelText: "No",
                    onOk: () => {
                        requestApproval({
                            role: 1,
                            requester_id: user_id,
                            type: approvalType.NEW_DRIVER_CARD_APPROVAL,
                            workflow: getApprovalWorkFlow(approvalType.NEW_DRIVER_CARD_APPROVAL),
                            ref_id: driver.id
                        }).then(() => {
                            notification.success({ message: "Request sent!" })
                        })
                    },
                })

                break

            case "Cancel Approval Request":

                CommonConfirmModal({
                    content: `Cancel Approval for ${driver.name}'s On-Boarding.`,
                    okText: "Yes",
                    cancelText: "No",
                    onOk: () => {
                        preApproveHandler('reject')
                    },
                    onCancel: () => { }
                })

                break;

            default:
                break;
        }

    }

    return (
        <Container>

            <div className='actions-wrapper' >

                <div>
                    <button onClick={backHandler} className='backIconWrapper' >
                        <ArrowLeftOutlined />
                    </button>

                    <h1>{editMode ? 'Edit' : ''} Driver Card</h1>
                </div>

                <div className='icons-wrapper' >
                    {editMode && <EditFilled onClick={() => setDisabled && setDisabled(false)} />}
                    <IconShare color={THEME.colors.primary} size={25} />
                    <DeleteFilled />
                    <PlusOutlined />
                </div>

            </div>

            {editMode && <div className='submenu-wrapper'>
                {menu.map(v => (
                    <a key={`driver-header-sub-${str.addDash(v.label)}`} onClick={() => subMenuClickHandler(v.label)}>{v.label}</a>
                ))}
            </div>}

            {editMode && <div className='submenu-wrapper'>
                <SecondMenu onMenuClick={event => subMenuClickHandler(event)} currentStatus={driver.status} />
            </div>}

            <PreApproveModal
                show={showPreApprove}
                onCancel={() => setShowPreApprove(false)}
                onReject={() => preApproveHandler('reject')}
                onApprove={() => preApproveHandler('approve')}
            />

        </Container>
    )
}

Header.propTypes = {
    onEvent: PropTypes.func,
    editMode: PropTypes.bool,
    setDisabled: PropTypes.func
}

export default Header
